(function () {
  var SELECTOR = '#dropahintModals a:not([href]):not([role])';

  function patch() {
    document.querySelectorAll(SELECTOR).forEach(function (anchor) {
      anchor.setAttribute('role', 'button');
    });
  }

  function run() {
    patch();
    var tries = 0;
    var timer = setInterval(function () {
      patch();
      if (++tries >= 10) clearInterval(timer);
    }, 1000);
  }

  function start() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 1200);
    }
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
